module.exports = __webpack_public_path__ + "static/img/logo-1@3x.ae9e290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-1@3x.png
// module id = R3by
// module chunks = 39